import type { CSSProperties, JSX } from 'react'

import type { Icon } from '.'

export function Keep({ className, style }: Readonly<Icon>): JSX.Element {
  const styles: CSSProperties = {
    fill: 'currentColor',
    stroke: '#000',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeWidth: 54.1168,
    ...style,
  }

  return (
    <svg
      className={className}
      id="Layer_1"
      version="1.1"
      viewBox="0 0 3000 3000"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
    >
      <path
        d="M2446,1572.8L1501,2508.6l-944.9-935.9C306.8,1330.2,301.3,931.3,544,682s641.5-254.8,890.8-12.1
 c24.1,23.4,46.2,48.7,66.3,75.7c209.1-278.1,604-334,882.1-124.9s334,604,124.9,882.1c-18.9,25.1-39.6,48.8-62.1,70.8"
        style={styles}
      />
    </svg>
  )
}

export default Keep
